import {observer} from 'mobx-react'
import Swipe, { SwipeItem } from 'swipejs/react'
import CONTENT from '../stores/Content'
import UI from '../stores/UI'
import HELP from '../stores/Help'
import BackgroundPicture from './BackgroundPicture'
import Markdown from './Markdown'
import Vimeo from './Vimeo'
import Video from './Video'
import Cross from '../svg/Cross'
import Spinner from '../svg/Spinner'

class MobileGallery extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      activeSlide: 0,
      ready: false
    }

    this.resizeTimer = null
  }

  componentDidMount() {
    let mySwipe = this.swipe;

    this.setState({
      ready: true,
      index: 0,
      resizing: false
    })

    window.addEventListener('orientationchange', this.handleRotate)
  }

  componentWillUnmount() {
    window.removeEventListener('orientationchange', this.handleRotate, false)
  }

  handleRotate = e => {

    this.setState({
      resizing: true
    })

    clearTimeout(this.resizeTimer)
    this.resizeTimer = setTimeout(() => {
      this.setState({
        resizing: false
      })
    }, 1200)
  }

  handleCallback = (index, elem) => {
    // Your own logic
    this.setState({
      caption: CONTENT.currentProjectImages[index].caption || '',
      index: index
    })

  }

  handleClose = e => {
    e.stopPropagation()
    this.back()
  }

  back() {

    this.refs.el.addEventListener('transitionend', e => {
      this.props.history.goBack()
    })

    this.setState({
      ready: false
    })
  }

  render() {

    const project = CONTENT.currentProject;
    const swiperOptions = {
      startSlide: this.state.index,
      speed: 300,
      auto: 0,
      draggable: true,
      continuous: true,
      autoRestart: false,
      disableScroll: true,
      stopPropagation: false,
      callback: this.handleCallback,
      transitionEnd: this.onTransitionEnd
    }
    const foregroundColor = project && project.foregroundColor ? project.foregroundColor : '#000000'
    const backgroundColor = project && project.backgroundColor ? project.backgroundColor : '#FFFFFF'

    return (
      <div className="pabs fix fs" ref="el" style={{
        opacity: this.state.ready ? 1 : 0,
        transition: `all ${1}ms`,
        zIndex: 1000
      }}>

        {project ? (
          <div className="fs" style={{
            backgroundColor: backgroundColor,
            color: foregroundColor,
            opacity: 1,
            transition: `opacity ${300}ms`
          }}>
            {!this.state.resizing ? (
              <Swipe ref={o => this.swipe = o} {...swiperOptions}>
                {CONTENT.currentProjectImages.map((slide, i) => {
                  return (
                    <SwipeItem className="fs" key={`slide-${i}`}>
                      <div className="fs rel">

                        {slide.video || slide.vimeo || slide.image ? (
                          <div className="rel" style={{ height: "100%" }}>
                            <div className="pabs fs padx2 innerx8">
                              {slide.video && this.state.index === i ? (
                                <Video file={slide.video} poster={slide.videoThumbnail} />
                              ) : slide.vimeo && this.state.index === i ? (
                                <Vimeo url={slide.vimeo} />
                              ) : slide.image ? (
                                <BackgroundPicture className="fs contain" {...HELP.getMedia(slide.image)} />
                              ) : null}
                            </div>
                          </div>
                        ) : slide.caption ? (
                          <div className="fs center txt-c">
                            <div className="max--skinny middle guttersx2">
                              <Markdown convert={slide.caption} />
                            </div>
                          </div>
                        ) : null}

                      </div>
                    </SwipeItem>
                  )
                })}
              </Swipe>
            ) : null}
          </div>
        ) : (
          <div className="fs" style={{
            opacity: 0,
            transition: `opacity ${300}ms`
          }} />
        )}

        <div className="p1 padx2 mobile-close" onTouchEnd={this.handleClose}>
          {UI.isLoading && UI.isTouch ? <Spinner fill={foregroundColor} /> : <Cross fill={foregroundColor} />}
        </div>

      </div>
    )
  }
}

export default observer(MobileGallery)



// WEBPACK FOOTER //
// ./app/javascript/packs/components/MobileGallery.js